module.exports = __webpack_public_path__ + "media/application/images/2023/01_still-1250x703-f6318ebe55e04a7ae22d478084aa31ce.png";